import { Component, Host, h, Element, Prop, State } from "@stencil/core";

import { StzhYoutubeLocalizedText } from "./stzh-youtube.localization";

// import { hasSlot } from "../../utils/utils";

/**
 * @slot prewiev-logo - Slot for preview logo
 * @slot prewiev-image - Slot for preview image
 */
@Component({
  tag: "stzh-youtube",
  styleUrl: "stzh-youtube.scss",
  scoped: true,
})
export class StzhYoutube {
  /** Translation strings */
  @Prop() localization: StzhYoutubeLocalizedText;

  /** URL to youtube video */
  @Prop() url: string = "";

  /**
   * Cookie name (used for showing/hiding cookie wall)
   * Will be prefixed with `stzh-components-iframe-confirm-`.
   */
  @Prop() cookie: string = "youtube";

  /**
   * Number of days the cookie is valid for.
   * If omitted or set to null or 0, the cookie expires when browser is closed.
   * Maximum is on year (365 days, is default).
   */
  @Prop() cookieExpires: number | null = 365;

  /** Whether preview should be skipped, if user passed the cookiewall before */
  @Prop() skipPreviewIfCookieAccepted: boolean = false;

  /** Whether preview should always be skipped */
  @Prop() skipPreview: boolean = false;

  @Element() element: HTMLStzhYoutubeElement;

  @State() previewSkipped = false;

  private handlePreviewSkipped = () => {
    this.previewSkipped = true;
  };

  async componentWillLoad() {
    if (!this.localization) {
      this.localization = await window.stzhComponents.utils.fetchTranslations(this.element, "youtube");
    }
  }

  render() {
    const classes = {
      "stzh-youtube": true,
    };

    const hasParams = this.url.includes("?");

    const url =
      this.url +
      (hasParams ? "&" : "?") +
      "html5=1" +
      "&showinfo=0" +
      "&rel=0" +
      "&modestbranding=0" +
      "&playsinline=1" +
      `&origin=${encodeURIComponent(window.location.protocol + "//" + window.location.host)}` +
      "&enablejsapi=1" +
      "&widgetid=1" +
      (this.previewSkipped ? "" : "&autoplay=1");

    return (
      <Host>
        <div class={classes}>
          <stzh-ratio>
            <stzh-iframe
              src={url}
              previewLabel={this.localization.previewLabel}
              previewIcon={"play"}
              cookie={this.cookie}
              cookieConfirmLabel={this.localization.confirmLabel}
              cookieConfirmIcon={"play"}
              cookieExpires={this.cookieExpires}
              skipPreview={this.skipPreview}
              skipPreviewIfCookieAccepted={this.skipPreviewIfCookieAccepted}
              onStzhPreviewSkip={this.handlePreviewSkipped}
            >
              <slot name="preview-logo" slot="preview-logo"></slot>
              <slot name="preview-image" slot="preview-image"></slot>
              <div slot="cookiewall-text" innerHTML={this.localization.confirmText}></div>
            </stzh-iframe>
          </stzh-ratio>
        </div>
      </Host>
    );
  }
}
